import { createSlice } from '@reduxjs/toolkit'
import _ from 'lodash'
import {
  handleFilterBody,
  handleFulfilled,
  handlePending,
  handleRejected,
} from './events'
import { initialState } from './model'
import { getAnnounceFilter } from 'src/services/eExamination'

const announceExaminerList = createSlice({
  name: 'announceExaminerList',
  initialState,
  reducers: {
    startLoadMore: (state) => {
      state.isLoadMore = true
    },
    stopLoadMore: (state) => {
      state.isLoadMore = false
    },
    setTab: (state, { payload }) => {
      state.tab = payload
      state.filter = []
      state.filterBody = { ...initialState.filterBody }
      state.isLoadMore = false
      handleFilterBody(state, payload)
    },
    setFilter: (state, { payload }) => {
      state.filter = payload
      state.filterBody.page = 1
      state.isLoadMore = false
      if (payload.length == 0) handleFilterBody(state, state.tab)
      else state.filterBody.classStatus = payload
    },
    setSearch: (state, { payload }) => {
      state.filterBody.search = payload
      state.filterBody.page = 1
      state.isLoadMore = false
    },
    setPeriod: (state, { payload }) => {
      const { startDate, endDate } = payload
      state.filterBody.startDate = startDate
      state.filterBody.endDate = endDate
      state.filterBody.page = 1
      state.isLoadMore = false
    },
    setLoadMore: (state) => {
      if (state.isLoadMore) return
      const limit = _.get(state.filterBody, 'limit', 20)
      const nextPage = state.filterBody.page + 1
      const maxPage = _.ceil(state.totalannounceList / limit)
      if (nextPage > maxPage) return
      state.isLoadMore = true
      state.filterBody.page = nextPage
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAnnounceFilter.fulfilled, handleFulfilled)
      .addCase(getAnnounceFilter.pending, handlePending)
      .addCase(getAnnounceFilter.rejected, handleRejected)
  },
})

export const {
  startLoadMore,
  stopLoadMore,
  setTab,
  setFilter,
  setSearch,
  setPeriod,
  setLoadMore,
} = announceExaminerList.actions

export default announceExaminerList.reducer
